<template>
  <div>
    <div ref="overlayElement" class="overlay-active-lr" v-if="showLoader">Loading...</div>
    <div class="flex">
      <div
        class="
          vx-col
          w-full
          lg:w-1/2
          sm:w-1/2
          mt-2
          ml-2
          consignment-add-analytics
        "
      >
        <vx-card class="p-2">
          <div class="flex justify-between text-center">
            <span>
              <p class="text-xl font-semibold">
                {{ selectedConsignments.length }}
              </p>
              <small class="text-grey">Total Consignments</small>
            </span>
            <span>
              <p class="text-xl font-semibold">
                {{ newConsignments.length }}
              </p>
              <small class="text-grey">New Consignments</small>
            </span>
            <span>
              <p class="text-xl font-semibold">
                {{ transhipmentConsignments.length }}
              </p>
              <small class="text-grey">Transhiping Consignment</small>
            </span>
          </div>
        </vx-card>
      </div>
      <div
        class="
          vx-col
          w-full
          lg:w-1/2
          sm:w-1/2
          mt-2
          mr-2
          ml-2
          consignment-manual-add
        "
      >
        <vx-card class="p-2">
          <vs-input
            class="inputx"
            placeholder="Lr No"
            label-placeholder="Lr No"
            v-model="manualLrNo"
            @keyup.enter="addManualAdd"
          />
        </vx-card>
      </div>
    </div>
    <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mt-2 ml-2"></div>
    <vs-table
      multiple
      v-model="selectedConsignmentsTable"
      pagination
      max-items="10"
      search
      stripe
      :data="consigmentData"
      @selected="handleConsignmentSelected"
      @input="handleInput"
      onlyClickCheckbox="true"
      ref="onlyConsignment"
    >
      <template slot="thead">
        <vs-th sort-key="consignmentLrNo">LR.No</vs-th>
        <vs-th sort-key="consignementFromBranchName">From - To</vs-th>
        <vs-th sort-key="consignor">Consignor</vs-th>
        <vs-th sort-key="consignee">Consignee</vs-th>
        <vs-th sort-key="consignmentPackagesTotalCnt">No.of Articles</vs-th>
        <vs-th sort-key="consignmentBookedDate">Booking Date</vs-th>

        <vs-th sort-key="consignmentBookingPaymentTypeName">Booking Type</vs-th>
        <vs-th sort-key="consignmentGrandTotalCharge">Freight Charges</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].consignmentLrNo">{{
            data[indextr].consignmentLrNo
          }}</vs-td>
          <vs-td :data="data[indextr].consignmentToBranchName"
            >{{ data[indextr].consignmentFromBranchName }} -
            {{ data[indextr].consignmentToBranchName }}</vs-td
          >
          <vs-td :data="data[indextr].consignor"
            >{{ data[indextr].consignor.consignmentConsignorName }} ({{
              data[indextr].consignor.consignmentConsignorMobileNo
            }})</vs-td
          >
          <vs-td :data="data[indextr].consignee"
            >{{ data[indextr].consignee.consignmentConsigneeName }} ({{
              data[indextr].consignee.consignmentConsigneeMobileNo
            }})</vs-td
          >
          <vs-td :data="data[indextr].consignmentPackagesTotalCnt">{{
            data[indextr].consignmentPackagesTotalCnt
          }}</vs-td>
          <vs-td :data="data[indextr].consignmentBookedDate">{{
            data[indextr].consignmentBookedDate | date(true)
          }}</vs-td>

          <vs-td :data="data[indextr].consignmentBookingPaymentTypeName">{{
            data[indextr].consignmentBookingPaymentTypeName
          }}</vs-td>
          <vs-td :data="data[indextr].consignmentGrandTotalCharge">{{
            data[indextr].consignmentGrandTotalCharge
          }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="flex flex-wrap justify-end mt-2">
      <vs-button @click="addConsignments" class="ml-auto"
        >Add Consignments</vs-button
      >
      <vs-button class="ml-4" type="border" color="warning">Cancel</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fromBranchId: {},
    lrStatus: {},
    currentBranchId: {},
    consignorId: {},
    consigneeId: {},
    toBranchId: {},
    consignmentIds: {},
    lrIds: {},
    frieghNos: {},
    orderColumn: {},
    orderBy: {}, 
     
    selectedConsignmentsListInput: [String, Number, Array],
  },
  components: {},
  mounted(){
    //code  
    },
  methods: {
    addConsignments() {
      this.$emit("selectedConsignments", this.selectedConsignments);
    },
    getConsignemnts(data) {
       this.$http.post("portage/getActiveLrs", data).then((response) => {
        console.log(response);
        // eslint-disable-next-line vue/no-mutating-props
        this.showLoader = false;
         this.masterConsigmentData = response.data.data;
        this.consigmentData = this.masterConsigmentData;
        this.newConsignments = this.masterConsigmentData.filter((entry) => {
          return entry.consignmentStatus == 1;
        });

        this.transhipmentConsignments = this.masterConsigmentData.filter(
          (entry) => {
            return entry.consignmentStatus == 4;
          }
        );
        if (
          this.selectedConsignmentsListInput &&
          this.selectedConsignmentsListInput.length > 0
        ) {
          //
          // console.log("Insertion");
          for (let i = 0; i < this.selectedConsignmentsListInput.length; i++) {
            let lrData = this.consigmentData.find(
              (data) =>
                data.consignmentLrNo ==
                this.selectedConsignmentsListInput[i].consignmentLrNo
            );
            // console.log("LR Data", lrData);
            if (lrData) {
              console.log("Selecting the Data");
              this.handleConsignmentSelected(lrData, true);
            }
          }
        }
        console.log(
          this.consigmentData,
          this.newConsignments,
          this.transhipmentConsignments
        );
        // this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[1].children[0].children[0].children[0].checked = false
      });
    },
    addManualAdd() {
      console.log(this.manualLrNo);
      this.handleConsignmentSelected(
        this.consigmentData.find(
          (data) => data.consignmentLrNo == this.manualLrNo
        ),
        true
      );
      this.manualLrNo = "";
    },
    handleConsignmentSelected(tr, isManual) {
      console.log(tr);
      if (tr != undefined) {
        const elementIndex = this.selectedConsignments.findIndex(
          (data) => data.consignmentId == tr.consignmentId
        );

        const index = this.consigmentData.findIndex(
          (data) => data.consignmentId == tr.consignmentId
        );
        if (elementIndex < 0) {
          if (
            tr.consignmentStatus == 1 &&
            tr.fromBranchId == this.localData.branchId
          ) {
            // New Consignment
            console.log("New Consignment", elementIndex, index);
            this.selectedConsignments.push(tr);
            if (isManual) {
              // alert("It manual");
              setTimeout(() => {
                //Header CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].checked = true;
                //Row CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                  index + 1
                ].children[0].children[0].children[0].checked = true;
                //Row Selection Update Class Name
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                  index + 1
                ].className =
                  "tr-values vs-table--tr tr-table-state-null is-selected selected";
              }, 10);
            }
          } else if (
            tr.consignmentStatus == 4 &&
            tr.fromBranchId == this.localData.branchId
          ) {
            alert(tr.fromBranchId);
            alert(this.localData.branchId);
            //Transhipment and wrong one
            this.selectedConsignmentsTable.pop();
            setTimeout(() => {
              if (this.selectedConsignmentsTable.length <= 0) {
                //Header CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].checked = false;
              }
              //Row CheckBox
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].children[0].children[0].children[0].checked = false;
              //Row Selection Update Class Name
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].className = "tr-values vs-table--tr tr-table-state-null";
            }, 10);
            alert("Consignment is not  in your branch!Please contact Admin");
            this.$vs.notify({
              title: "Consignment is not  in your branch!Please contact Admin",
              color: "danger",
              position: "top-right",
            });
          } else if (
            tr.consignmentStatus == 4 &&
            tr.fromBranchId != this.localData.branchId
          ) {
            //tranship and current branch
            this.selectedConsignments.push(tr);
            if (isManual) {
              // alert("It manual");
              setTimeout(() => {
                //Header CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].checked = true;

                //Row CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                  index + 1
                ].children[0].children[0].children[0].checked = true;
                //Row Selection Update Class Name
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                  index + 1
                ].className =
                  "tr-values vs-table--tr tr-table-state-null is-selected selected";
              }, 10);
            }
          } else {
            this.selectedConsignmentsTable.pop();
            setTimeout(() => {
              if (this.selectedConsignmentsTable.length <= 0) {
                //Header CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].checked = false;
              }
              //Row CheckBox
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].children[0].children[0].children[0].checked = false;
              //Row Selection Update Class Name
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].className = "tr-values vs-table--tr tr-table-state-null";
            }, 10);
          }
        } else if (elementIndex >= 0) {
          // console.log("Remove Consignment", elementIndex, index);
          this.selectedConsignments.splice(elementIndex, 1);
          // console.log(this.selectedConsignments);
          if (isManual) {
            setTimeout(() => {
              if (this.selectedConsignmentsTable.length <= 0) {
                //Header CheckBox
                this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[0].checked = false;
              }
              //Row CheckBox
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].children[0].children[0].children[0].checked = false;
              //Row Selection Update Class Name
              this.$refs.onlyConsignment.$el.children[1].children[0].children[0].children[
                index + 1
              ].className = "tr-values vs-table--tr tr-table-state-null";
            }, 10);
          }
        }
      }
    },
    handleInput(_val) {
      // console.log(val);
      // console.log(this.$refs);
    },
  },
  data() {
    return {
      showLoader:true,
      selectedConsignmentsTable: [],
      masterConsigmentData: [],
      consigmentData: [],
      localData: JSON.parse(localStorage.getItem("sstUnData")),
      selectedConsignments: [],
      manualLrNo: null,
      newConsignments: [],
      transhipmentConsignments: [],
    };
  },
  beforeMount() {
        // this.gridApi.showLoadingOverlay();

    this.getConsignemnts({
      fromBranchId: this.fromBranchId,
      //   lrStatus: this.lrStatus,
      currentBranchId: this.currentBranchId,
      //   consignorId: this.consignorId,
      //   consigneeId: this.consigneeId,
      //   toBranchId: this.toBranchId,
      //   consignmentIds: this.consignmentIds,
      //   lrIds: this.lrIds,
      //   frieghNos: this.frieghNos,
      //   orderColumn: this.orderColumn,
      //   orderBy: this.orderBy,
    });
  },
};
</script>

<style >
</style>
<style lang="scss">
.consignment-add-analytics {
  .vx-card__body {
    padding: 0.1rem;
  }
}

.consignment-manual-add .vx-card__body {
  padding: 1.8rem !important;
}
.overlay-active-lr{
  position: absolute;
  background: #00000042;
  width: 90%;
  height: 30rem;
  display: block;
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size:3rem;
  
}
</style>